export const passwordRegex = /^(?=.*[0-9])(?=.*[\s~`!@#$%\^&*+=\-\[\]\\';,/{}|\\":<>\?()\._])(?=.*[a-zA-Z]).{8,16}$/;
